import Vue from "vue";
import Vuex from "vuex";
import { getCompanyList, getCompanyInfo } from "@/api/request/snkd.user";
import { getStorage } from "@/utils/storage";

import modules from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  state: {
    companyList: [],
    farmId: null,
    companyId: null,
    curCompanyInfo: null,
  },
  mutations: {
    setCompanyList(state, list) {
      state.companyList = list;
    },
    setFidAndCid(state) {
      const farmInfo = getStorage("FARMINFO");
      if (farmInfo) {
        state.farmId = farmInfo.farmId;
        state.companyId = farmInfo.companyId;
      }
    },
    setCurCompanyInfo(state, data) {
      state.curCompanyInfo = data;
    },
  },
  actions: {
    getCompanyList({ commit }) {
      return new Promise((resolve) => [
        getCompanyList().then((res) => {
          // console.log("企业列表：", res);
          if (res.respCode === 0) {
            commit("setCompanyList", res.obj.list);
            resolve(res.obj.list);
          } else {
            resolve([]);
          }
        }),
      ]);
    },
    // 获取当前企业信息
    // companyId 可选：优先使用调用方传入（如路由 query 上的企业），缺省再取缓存 COMPANYINFO。
    // 这样即使 COMPANYINFO 缓存缺失/过期，只要登录态有效仍能取到对应企业信息。
    async getCurCompanyInfo({ commit, state }, companyId) {
      const stored = getStorage("COMPANYINFO");
      const targetId = companyId || (stored && stored.companyId) || null;
      if (state.curCompanyInfo) {
        const cachedId =
          state.curCompanyInfo.userCompany &&
          state.curCompanyInfo.userCompany.companyId;
        // 未指定目标企业，或目标企业与已缓存一致时，直接用缓存
        if (!targetId || !cachedId || String(cachedId) === String(targetId)) {
          return state.curCompanyInfo;
        }
      }
      if (!targetId) {
        return null;
      }
      const res = await getCompanyInfo({ companyId: targetId });
      if (res.respCode === 0 && res.obj) {
        commit("setCurCompanyInfo", res.obj);
        return res.obj;
      }
      return null;
    },
  },
});
